import * as React from "react";
import { Link } from "react-router-dom";
import { ArrowDown, Plus } from "lucide-react";
import { useContactModal } from "../context/contactModal";
export function ProductHero({ product }) {
  const { openInquiry } = useContactModal();
  return (
    <React.Fragment>
      <section className="industrial-hero">
        <div className="catalog-wrap">
          <nav className="catalog-breadcrumb" aria-label="Breadcrumb">
            <Link to="/products">Products</Link>
            <span>/</span>
            <span>{product.name}</span>
          </nav>
          <div className="industrial-heading">
            <h1>{product.name}</h1>
            <p>
              {product.category}
              <br />
              {product.status}
            </p>
          </div>
          <figure className="industrial-figure">
            <span className="industrial-ghost" aria-hidden="true">
              {product.category === "Robotics" ? "ROBOTICS" : "CAPTURE"}
            </span>
            <img src={product.image} alt={`${product.name} reference`} />
            <Plus className="industrial-cross" size={26} aria-hidden="true" />
            <figcaption>{product.imageNote}</figcaption>
          </figure>
          <div className="industrial-caption">
            <h2>{product.subtitle}</h2>
            <a href="#product-overview" className="catalog-text-link">
              Discover the details <ArrowDown size={18} />
            </a>
          </div>
        </div>
      </section>
      <section id="product-overview" className="catalog-wrap industrial-overview">
        <div>
          <p className="catalog-kicker">System overview</p>
          <h2>
            Built around
            <br />
            your research.
          </h2>
          <p>{product.intro}</p>
          <div className="catalog-actions">
            <button className="catalog-button" onClick={() => openInquiry(product.name)}>
              Request a Quote
            </button>
            <button
              className="catalog-button catalog-button-outline"
              onClick={() => openInquiry(product.name, "Talk to an Engineer")}
            >
              Talk to an Engineer
            </button>
          </div>
        </div>
        <div>
          <dl className="industrial-metrics">
            {product.metrics.map(([n, r]) => (
              <div key={r}>
                <dt>{r}</dt>
                <dd>{n}</dd>
              </div>
            ))}
          </dl>
          <p className="catalog-note">
            Configuration, lead time and delivery scope confirmed with your inquiry.
          </p>
          {["atlas-m", "atlas-r1", "fmg-imu"].includes(product.slug) && (
            <a className="catalog-text-link" href="#product-model">
              Explore in 3D <ArrowDown size={18} />
            </a>
          )}
        </div>
      </section>
    </React.Fragment>
  );
}
